import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MobileDetectorService } from '../../../../services/mobileDetector/mobile-detector.service';
import { Filters, UserTable } from 'src/app/api/interfaces/user';
import { StudentService } from 'src/app/services/admin/student/student.service';
import { SnackbarService } from 'src/app/utils/snackbar/snackbar.service';
import { Canal, Participante } from 'src/app/api/interfaces/messages';
import { MessagesService } from 'src/app/api/services/messages/messages.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @Output() searchCanalesEvent = new EventEmitter<Canal[]>();
  @Output() searchCanalesEmptyEvent = new EventEmitter<Canal[]>();

  isMobile: boolean = false;
  messagesForm = new FormGroup({
    nombreApellido: new FormControl(),
  });

  filters: Filters = {
    nombre: "",
    apellido: "",
    nombreApellido: "",
    estado: "",
    entrenamientoTipoId: "",
    entrenamientoNivelId: "",
    entrenadorId: "",
    leido: ""
  };

  cantidadCanalesSolicitados: number = 0;
  totalPerPage: number = 100;
  page: number = 0;

  loaded: boolean = false;

  participantesData: Participante []= [];
  studentData: UserTable[] = [];
  canales: Canal[] = [];
  
  constructor(
    private mobileDetectorService: MobileDetectorService,
    private studentService: StudentService,
    private snack: SnackbarService,
    private messagesService: MessagesService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.mobileDetectorService.isMobile();
  }

  /**
   * Request student data and convert to Partipante interface. Call getCanal to build canales and emit the data
   */
  onSubmit() {
    this.studentData = [];
    this.canales = [];
    this.cantidadCanalesSolicitados = 0;
    this.filters.nombreApellido = this.messagesForm.value.nombreApellido;
    this.participantesData = [];
    this.studentService.getStudentsWithPaginator(this.totalPerPage, this.page, this.filters)
      .subscribe(students => {
        if (students.length == 0) {
          this.loaded = true;
          this.searchCanalesEmptyEvent.emit([]);
        } else {
          students.forEach(student => {
            const participante: Participante = {
              flgLeido : false,
              idUsuario: student.usuarioId,
              descripcionUsuario: `${student.nombre} ${student.apellido}`,
            };
            this.participantesData.push(participante);
            this.getCanal(participante.idUsuario);
          });
          this.loaded = true;
        }
      },
        error => {
          this.snack.snackTranslate('snacks.error.generic')
          console.error(error);
          this.loaded = true;
        });
  }

  clear() {
    this.cantidadCanalesSolicitados = 0;
    this.messagesForm.patchValue({nombreApellido: ""});
    this.searchCanalesEvent.emit(null);
  }

  getCanal(usuarioId: number) {
    this.messagesService.getCanalUsuarioId(usuarioId).subscribe(response => {
      if(response.content[0]) {
        this.canales.push(response.content[0]);
      }
      //prevent searchCanalesEvent to be emited before all the data is loaded
      this.cantidadCanalesSolicitados ++;
      if(this.cantidadCanalesSolicitados == this.participantesData.length) {
        this.searchCanalesEvent.emit(this.canales);
      }
    },
      error => {
        console.error(error);
        this.snack.snackTranslate('snacks.error.generic');
      });
  }

}
